/**
 * ==================================================
 * Pricing Plans Toggle Script Logic
 * ==================================================
 */
document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".pricing-section");
  if (!sections.length) return;

  sections.forEach((section) => {
    const buttons = section.querySelectorAll(".billing-btn");
    if (!buttons.length) return;

    const monthlyPrice = section.querySelectorAll(".monthly-price");
    const yearlyPrice = section.querySelectorAll(".yearly-price");
    const monthlyText = section.querySelectorAll(".monthly-text");
    const yearlyText = section.querySelectorAll(".yearly-text");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        buttons.forEach(btn => btn.classList.remove("active"));
        button.classList.add("active");

        const type = button.dataset.type;

        if (type === "monthly") {
          monthlyPrice.forEach(item => {
            item.style.display = "flex";
            item.classList.add("fade-in");
          });
          monthlyText.forEach(item => {
            item.style.display = "block";
            item.classList.add("fade-in");
          });
          yearlyPrice.forEach(item => {
            item.style.display = "none";
            item.classList.remove("fade-in");
          });
          yearlyText.forEach(item => {
            item.style.display = "none";
            item.classList.remove("fade-in");
          });
        } else {
          monthlyPrice.forEach(item => {
            item.style.display = "none";
            item.classList.remove("fade-in");
          });
          monthlyText.forEach(item => {
            item.style.display = "none";
            item.classList.remove("fade-in");
          });
          yearlyPrice.forEach(item => {
            item.style.display = "flex";
            item.classList.add("fade-in");
          });
          yearlyText.forEach(item => {
            item.style.display = "block";
            item.classList.add("fade-in");
          });
        }
      });
    });
  });
});